import { render, staticRenderFns } from "./ProxyApplication.vue?vue&type=template&id=2dff767c"
import script from "./ProxyApplication.vue?vue&type=script&lang=js"
export * from "./ProxyApplication.vue?vue&type=script&lang=js"
import style0 from "./ProxyApplication.vue?vue&type=style&index=0&id=2dff767c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports